<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})"><i class="fas fa-long-arrow-alt-left"></i> <b>Home</b></a>
                    </span>
                </div>
            </div>
            <!-- Test Socket Buttons -->
            <!--<div class="form-group text-center mt-3">
                <button class="btn btn-success mr-2" @click="triggerDeviceStatusUpdate('internet_connected')">
                    <i class="fas fa-wifi"></i> Simulate Online
                </button>
                <button class="btn btn-danger" @click="triggerDeviceStatusUpdate('internet_disconnected')">
                    <i class="fas fa-wifi"></i> Simulate Offline
                </button>
            </div>-->
            <div class="profile-section pt-2">
                 <form class="m-4">
                    <div class="input-group mb-3">
                        <input type="password" v-model="currentPassword" class="form-control password-input"  placeholder="Enter current password">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">
                            <i class="fa fa-eye-slash" aria-hidden="true" v-if="showPassword == false" @click="togglePasswordDisplay(true)"></i>
                            <i class="fa fa-eye" aria-hidden="true" v-if="showPassword == true" @click="togglePasswordDisplay(false)"></i>
                            </span>
                        </div>
                    </div>
                    <div class="input-group mb-3">
                        <input type="password" v-model="newPassword" class="form-control password-input"  placeholder="Enter new password">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">
                            <i class="fa fa-eye-slash" aria-hidden="true" v-if="showPassword == false" @click="togglePasswordDisplay(true)"></i>
                            <i class="fa fa-eye" aria-hidden="true" v-if="showPassword == true" @click="togglePasswordDisplay(false)"></i>
                            </span>
                        </div>
                    </div>
                    <div class="input-group mb-3">
                        <input type="password" v-model="confirmNewPassword" class="form-control password-input" placeholder="Confirm new password">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">
                            <i class="fa fa-eye-slash" aria-hidden="true" v-if="showPassword == false" @click="togglePasswordDisplay(true)"></i>
                            <i class="fa fa-eye" aria-hidden="true" v-if="showPassword == true" @click="togglePasswordDisplay(false)"></i>
                            </span>
                        </div>
                    </div>
                    <div class="form-group text-center">
                        <button class="btn btn-primary login-btn" :disabled="isDisabled" @click="changePassword()">Update Password
                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                        </button>
                    </div>
                 </form>
            </div>
            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>
<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
import UserService from "../../services/UserService";

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter
  },
  data() {
    return {
        profileId: this.$route.query.profileId || this.$route.query.profile_id,
        serialNumber: this.$route.query.serialNumber,
        isDisabled: false,
        paymentHistoryData: [],
        showPassword: false,
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        socket: null,
    }
  },
  methods: {
    async changePassword() {
        this.isDisabled = true;
        let data = { old_password: this.currentPassword, new_password: this.newPassword, confirm_password: this.confirmNewPassword }
      await KidsService.changePassword(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            localStorage.setItem('token', "");
            this.$router.push('login');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    togglePasswordDisplay(showPassword) {
      if (showPassword == true) {
        $('.password-input').attr('type', 'text');
      } else {
        $('.password-input').attr('type', 'password');
      }
      this.showPassword = showPassword;
    },
    triggerDeviceStatusUpdate(event = 'internet_connected') {
        if (!this.socket || !this.socket.connected) {
            this.$toast.error("Socket not connected");
            return;
        }

        const payload = {
            serialNumber: 'R58N60EHGXW',
            event: event,
            latitude: 23.033863,
            longitude: 72.585022,
            deviceDateTime: "2026-06-02 16:33:45",
            batteryPercentage: 38,
            timestamp: new Date().toISOString(),
            token: localStorage.getItem('token')
        };

        this.socket.emit('device_status_update', payload);
        this.$toast.success(`Emitted: ${event}`);
        console.log("Emitted device_status_update:", payload);
    },
    /*applyNextInvoiceDiscount() {
        this.isDisabled = true;
        let data = { subscriptionId: "sub_1TM1ogLA8AkLfo94I007Szjv" }
        UserService.applyNextInvoiceDiscount(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },*/
  },
  beforeMount() {
    //this.applyNextInvoiceDiscount();
  },
  mounted() {
        this.socket = io(process.env.VUE_APP_API_BASE_URL, {
            auth: {
                serialNumber: 'R58N60EHGXW',
                token: localStorage.getItem('token')
            }
        });

        this.socket.on("connect", () => {
            console.log("Socket connected for testing:", this.socket.id);
        });

        this.socket.on("connect_error", (err) => {
            console.error("Socket Connect Error:", err.message);
        });
    },

    beforeDestroy() {
        if (this.socket) {
            this.socket.disconnect();
        }
    },
}
</script>